module.exports = __webpack_public_path__ + "assets/img/customers3.3f165366.png";